export const SOCIAL_POST_PUBLICATION_SUCCESS = "success"
export const SOCIAL_POST_PUBLICATION_PENDING = "pending"
export const SOCIAL_POST_PUBLICATION_ERROR = "error"
export const SOCIAL_POST_PUBLICATION_UNKNOWN = "unknown"
